// source: messaging/common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

goog.exportSymbol('proto.com.alfredcamera.protobuf.OperationResult', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.OperationResult.ErrorCode', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.RpcMessage', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.RpcMessage.MessageType', null, global);
goog.exportSymbol('proto.com.alfredcamera.protobuf.RpcMessage.ServiceType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.RpcMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.RpcMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.RpcMessage.displayName = 'proto.com.alfredcamera.protobuf.RpcMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.alfredcamera.protobuf.OperationResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.alfredcamera.protobuf.OperationResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.alfredcamera.protobuf.OperationResult.displayName = 'proto.com.alfredcamera.protobuf.OperationResult';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.RpcMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.RpcMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.RpcMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    service: jspb.Message.getFieldWithDefault(msg, 2, 0),
    control: jspb.Message.getFieldWithDefault(msg, 3, 0),
    id: jspb.Message.getFieldWithDefault(msg, 4, 0),
    encrypted: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    payload: msg.getPayload_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage}
 */
proto.com.alfredcamera.protobuf.RpcMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.RpcMessage;
  return proto.com.alfredcamera.protobuf.RpcMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.RpcMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage}
 */
proto.com.alfredcamera.protobuf.RpcMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.RpcMessage.MessageType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.com.alfredcamera.protobuf.RpcMessage.ServiceType} */ (reader.readEnum());
      msg.setService(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setControl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEncrypted(value);
      break;
    case 6:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPayload(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.RpcMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.RpcMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.RpcMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getService();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getControl();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getEncrypted();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPayload_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      6,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.RpcMessage.MessageType = {
  REQUEST: 0,
  RESPONSE: 1
};

/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.RpcMessage.ServiceType = {
  SERVICE_RESERVED: 0,
  CAMERA_INFO: 1,
  CAMERA_SETTINGS: 2,
  CAMERA_STATUS: 3,
  RTC_SIGNALLING: 4,
  LIVE_CONTROL: 5,
  DEVICE_MANAGEMENT: 6,
  MEDIA_ACCESS: 8
};

/**
 * optional MessageType type = 1;
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage.MessageType}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getType = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.RpcMessage.MessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.RpcMessage.MessageType} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ServiceType service = 2;
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage.ServiceType}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getService = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.RpcMessage.ServiceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.RpcMessage.ServiceType} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setService = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 control = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getControl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setControl = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 id = 4;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool encrypted = 5;
 * @return {boolean}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getEncrypted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setEncrypted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bytes payload = 6;
 * @return {!(string|Uint8Array)}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getPayload = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * optional bytes payload = 6;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getPayload_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPayload()));
};


/**
 * optional bytes payload = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.getPayload_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPayload()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.com.alfredcamera.protobuf.RpcMessage} returns this
 */
proto.com.alfredcamera.protobuf.RpcMessage.prototype.setPayload = function(value) {
  return jspb.Message.setProto3BytesField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.toObject = function(opt_includeInstance) {
  return proto.com.alfredcamera.protobuf.OperationResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.alfredcamera.protobuf.OperationResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OperationResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
    settingsRevision: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.alfredcamera.protobuf.OperationResult}
 */
proto.com.alfredcamera.protobuf.OperationResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.alfredcamera.protobuf.OperationResult;
  return proto.com.alfredcamera.protobuf.OperationResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.alfredcamera.protobuf.OperationResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.alfredcamera.protobuf.OperationResult}
 */
proto.com.alfredcamera.protobuf.OperationResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.com.alfredcamera.protobuf.OperationResult.ErrorCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSettingsRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.alfredcamera.protobuf.OperationResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.alfredcamera.protobuf.OperationResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.alfredcamera.protobuf.OperationResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSettingsRevision();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.alfredcamera.protobuf.OperationResult.ErrorCode = {
  OK: 0,
  TIMEOUT: -1,
  RESOURCE_UNAVAILABLE: -2,
  PERMISSION_DENIED: -3,
  FEATURE_UNAVAILABLE: -4,
  UNIMPLEMENTED: -5,
  INVALID_ARGUMENT: -6,
  UNKNOWN_ERROR: -900
};

/**
 * optional ErrorCode code = 1;
 * @return {!proto.com.alfredcamera.protobuf.OperationResult.ErrorCode}
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.getCode = function() {
  return /** @type {!proto.com.alfredcamera.protobuf.OperationResult.ErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.com.alfredcamera.protobuf.OperationResult.ErrorCode} value
 * @return {!proto.com.alfredcamera.protobuf.OperationResult} returns this
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.alfredcamera.protobuf.OperationResult} returns this
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 settings_revision = 3;
 * @return {number}
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.getSettingsRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.alfredcamera.protobuf.OperationResult} returns this
 */
proto.com.alfredcamera.protobuf.OperationResult.prototype.setSettingsRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.com.alfredcamera.protobuf);
